export default __webpack_public_path__ + "static/media/videoModal.b808529f.png";